/*
 * The module's typed translator: core's accessor over the module's own catalogue, so a key that is
 * not in `en` and a missing placeholder are both compile errors inside the module too, which is what
 * makes `react/jsx-no-literals` affordable here.
 *
 * The catalogue is imported as a *type*. Its text is the namespace the module hands the router from
 * `i18n()` (`../index.ts`), which the router registers before the first render; importing `en` as a
 * value here would pull all of chat's copy — every screen imports this file — into the entry chunk,
 * about 6 KB gzip that every first paint would wait for, the sign-in screen's included.
 *
 * Core's own `t()` is typed over the application's catalogue and cannot answer a "chat.*" key; the
 * placeholder machinery is shared rather than copied, so the two accessors cannot drift. A core
 * component that only renders a key it is handed takes `AnyKey`, so a chat key needs no cast.
 */

import { namespaceT } from "../../../core/i18n/index.ts"
import type { ArgsOf } from "../../../core/i18n/t.ts"
import type { en } from "./en.ts"

export type ChatCatalogue = typeof en
export type ChatKey = keyof ChatCatalogue
export type ChatArgs<K extends ChatKey> = ArgsOf<ChatCatalogue, K>

/** The text of one chat key, with its placeholders filled in. */
export const t = namespaceT<ChatCatalogue>("chat")
